import Partnership from './Partnership';

export default Partnership; 